import { TextArea } from "@classdojo/web/nessie";
import { TEXT_FIELD_HEIGHT } from "@classdojo/web/nessie/components/TextField";
import { translate } from "@classdojo/web/utils/translate";
import React from "react";
import { ToolPayload } from "src/pods/toolkitData/components/EditableSetup";

export type TodayEditProps = {
  onEdit: (payload: ToolPayload, disabled?: boolean) => void;
  payload: ToolPayload;
};

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
export default class TodayEdit extends React.Component<TodayEditProps> {
  render() {
    return (
      <TextArea
        label={translate({
          str: "dojo.toolkit:today.text_placeholder",
          fallback: "Share daily announcements, a welcome message, morning work, etc.",
        })}
        rows={3}
        onChange={this.onQuestionChange}
        value={this.props.payload ? this.props.payload.text : ""}
        fixedHeight={TEXT_FIELD_HEIGHT * 2}
      />
    );
  }

  onQuestionChange = (value: string) => {
    const text = value;
    this.props.onEdit({ text }, !text);
  };
}
